import React from 'react'

import Achuth from '../images/achuth_gowda3.png'
import Shubha from '../images/Subhalakshmi.jpg'
import Pooja from '../images/Pooja.jpeg'

import stand1 from '../images/stand_out/service_offering.png'
import stand2 from '../images/stand_out/experienced_professionals.png'
import stand3 from '../images/stand_out/hassle_execution.png'
import stand4 from '../images/stand_out/diverse_offering.png'
import stand5 from '../images/stand_out/client_testimonials.png'

import call from '../images/call.png'


import {BiLogoLinkedin} from 'react-icons/bi'
import {IoLogoWhatsapp} from 'react-icons/io'
import {IoMdCall} from 'react-icons/io'
import {AiOutlineMail} from 'react-icons/ai'
import Typist from 'react-typist';
import { mobile } from '../constant/Appconstants'

function About() {

  const employee = [
        // {
        //   name:'Achuth Gowda',
        //   des:'Founder - Fidelitus Corp',
        //   linkedIn:'https://www.linkedin.com/in/suhasini-deshpande-a6639711/',
        //   img:Achuth,
        //   whatsapp:'https://api.whatsapp.com/send?phone=919845036943&text=Hi%20I%20would%20like%20to%20connect%20with%20you',
        //   gmail:'mailto:suhasini@fidelituscorp.com',
        //   phone:'tel:+91 9845036943',
        // },
        {
          name:'Shubha Laxmi P Alva',
          des:'Director - Facility Management Services',
          linkedIn:'https://www.linkedin.com/in/santhosh-s-b4888b138',
          img:Shubha,
          whatsapp:'https://api.whatsapp.com/send?phone=919845083654&text=Hi%20I%20would%20like%20to%20connect%20with%20you',
          gmail:'mailto:santhosh.s@fidelituscorp.com',
          phone:'tel:+91 9845083654'
        },
        {
          name:'Pooja J',
          des:'Director - Facility Management Services',
          linkedIn:'https://www.linkedin.com/in/joby-joseph-fredy-6a91721ba/',
          img:Pooja,
          whatsapp:'https://api.whatsapp.com/send?phone=919845090850&text=Hi%20I%20would%20like%20to%20connect%20with%20you',
          gmail:'mailto:joby.fredy@fidelituscorp.com',
          phone:'tel:+91 9845090850'
        }
  ]

  const stand_out = [
    {
      img:stand1,
      name:'Customer-Centric Approach',
      val:'Your needs are at the heart of our solutions, ensuring personalized and effective services.'
    },
    {
      img:stand2,
      name:'Experienced Professionals',
      val:'Our team of skilled experts guarantees unmatched proficiency in facility management.'
    },
    {
      img:stand3,
      name:'Hassle-Free Execution',
      val:'We take full responsibility, ensuring smooth operations and minimal disruptions.'
    },
    {
      img:stand4,
      name:'Diverse Service Offerings',
      val:'From security to landscaping, we offer a comprehensive range of facility management solutions.'
    },
    {
      img:stand5,
      name:'Client Testimonials',
      val:'Our satisfied clients speak volumes about the quality of our services and dedication.'
    },
  ]

  
  return (
    <div className='w-full h-full overflow-hidden'>
        <div className='min-h-[200px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-contain md:bg-cover bg-no-repeat w-full bg-about_bg'>
          <div data-aos="fade-left" className='absolute top-[3%] md:top-[15%]  w-[75%] md:w-[35%]' >
            <div className='border-l w-full border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[15%]'>
                <h6 className='text-[18px] md:text-[21px] 2xl:text-[24px] text-[#000] font_thicker font-[800]  '>About Fidelitus Facility Management Services</h6>
                <h6 className='text-[13px] md:text-[14px] 2xl:text-[17px] text-[#000] font_normal'>Fidelitus Facility Management Services is a trusted partner delivering end-to-end facility
solutions across India. We specialize in providing skilled manpower and operational expertise
that ensures efficiency, safety, and compliance for businesses of all sizes.</h6>
            </div>
          </div>
        </div>
        

        <div className='md:flex items-center border-b border-slate-100 justify-center md:w-[100vw] px-[5%] md:px-[10%] py-[2%] mx-auto mt-0'>
        <div className='md:w-[50%] h-[110%]'>
        <img alt="achuthGowda" src={Achuth} className='overflow-hidden  w-[100%] h-[120%] object-cover mx-auto  md:mt-4 transition duration-500 cursor-pointer  ' />
        </div>
        <div className='md:w-[70%] mt-10 md:ml-10'>
            <h6 className="text-[17px] 2xl:text-[20px] font_medium">Achuth Gowda <span>(MRICS)</span></h6>
            <h6 className="text-[10px] 2xl:text-[13px] text-slate-400 font_medium">Founder and Managing Director</h6>
            {/* <h6 data-aos="fade-up" className="text-[14px] mt-4 font_normal">Professional Member of The Royal Institution of Chartered Surveyors (MRICS) has a vision to make Fidelitus Corp a leading service provider in corporate real estate industry across verticals. He provides leadership and direction to ensure the company achieves its strategic objectives. </h6> */}
            <h6 data-aos="fade-up" className="text-[14px] 2xl:text-[17px] mt-4 font_normal">Under his leadership, Fidelitus Corp has grown to become a leader in commercial real estate transactions and a trusted advisory real estate company in Bangalore. His leadership skills since 2013 has led to the companies growth and branch out into many verticals and grow in each one of them. His business acumen has lead the company to develop its core services as well as increase its revenue from other domains. Achuth Gowda is the recipient of the prestigious Nada Prabhu Kempegowda Award 2020.</h6>

            <h6 data-aos="fade-up" className="text-[14px] 2xl:text-[17px] mt-4 font_normal">A Founder is the first employee of the organization and when they treat even employee as an EMPLOYER those individuals develop a sense of responsibility & belongingness towards the company and the success derived out of such efforts transcends to a whole new level!</h6>
        </div>
      </div>


        <div className='pt-10 md:pt-20'>
            <h6 data-aos="fade-left" data-aos-delay="300" className='group font_thicker text-center text-[21px] 2xl:text-[24px]'>Our  <span className='text-[#4190ac]'>Team</span> Experts</h6>
            <div data-aos="fade-right" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
            <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
            <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
            </div>
            <h6 className='text-center mt-2 text-gray-600 w-[90%] md:w-[70%] mx-auto text-[14px] 2xl:text-[17px] font_normal'>Meet our exceptional team of professionals who are passionate about elevating facility management standards. With their skills and dedication, we guarantee seamless execution and utmost client satisfaction.</h6>
             
          <div className="grid grid-cols-2 md:grid-cols-2 place-items-center md:py-10 md:px-[20%]">
            {employee?.map((e,i)=>(
            <div data-aos="fade-up" key={i} className='w-[100%] min-h-[200px] grid place-items-center relative overflow-hidden mt-10 md:mt-0  md:mx-10 px-5 '> 
              <img alt={e?.name} src={e?.img} className='w-[200px]  md:w-[150px] md:h-[150px]  rounded-full object-cover hover:scale-110 transition duration-500 cursor-pointer object-cover' />

              <div>
                      <h6 className='text-[14px] 2xl:text-[17px] text-center font_medium mt-2 font-[700]'>{e?.name}</h6>
                      <h6 className='text-[12px] 2xl:text-[15px] text-center  font_normal font-[500]'>{e?.des}</h6>

                      <div className='border-t mt-2 text-black min-w-[120px] w-[100%]'>
                      <span className='flex w-[150px] items-center mx-auto justify-center mt-2 w-[100%] text-slate-400'>
                          {/* <a className='h-full' href={e?.linkedIn} target='_blank'>
                          <BiLogoLinkedin className='px-[2px] mr-5 cursor-pointer' />
                          </a>
                          <a className='h-full' href={e?.gmail} target='_blank'>
                          <AiOutlineMail className='px-[2px] cursor-pointer' />
                          </a> */}
                          {/* <a className='h-full' href={e?.phone} target='_blank'>
                          <IoMdCall className='px-[2px] cursor-pointer' />
                          </a>
                          <a className='h-full' href={e.whatsapp} target='_blank'>
                          <IoLogoWhatsapp className='px-[2px] cursor-pointer' />
                          </a> */}

                      </span>
                      </div> 
              </div>  
            </div>  
          ))}
          </div>

          <div data-aos="fade-left" className='mt-10 md:mt-0'>
          <h6 className=' mt-2 text-gray-600 w-[90%] md:w-[70%] font_normal mx-auto text-[14px] 2xl:text-[17px]'><span className='font-[800] font_thicker text-[#4190ac]'>Fidelitus IFMS</span> is a competently proficient 24/7 Integrated Facility Management company. We are highly trusted by our patrons to offer customized end-to-end services as per their requirements which ascertain our integrity in the industry. </h6>
          <h6 className=' mt-5 text-gray-600 w-[90%] md:w-[70%] font_normal mx-auto text-[14px] 2xl:text-[17px]'>Our extraordinary commitments in services and customer gratification are the secret to our accomplishment and trust we have generated in the industry. Our processes are eco-friendly. Our facilities are driven by outsourcing non-core activities in both the private and public sectors.  </h6>
          <h6 className=' mt-5 text-gray-600 w-[90%] md:w-[70%] font_normal mx-auto text-[14px] 2xl:text-[17px]'>Our team takes it as a mission to deliver the best output by using superior approaches, equipment and workforce. We are a comprehensive acquiescence sensitive organisation.  </h6>
          </div>



          <div className='md:flex '>

{/* Vision Column */}
<div data-aos="fade-right" className='flex-col items-center justify-center w-full py-16 mt-20 bg-gray-100 border-gray-200 md:border-r'>

  <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>
    <span className='text-[#4190ac]'>Vision</span>
  </h6>

  <div className='flex items-center justify-center w-full mt-1'>
    <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
    <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
  </div>

  <h6 className=' md:mt-5 text-center font_normal text-black w-[90%] md:w-[70%] mx-auto text-[14px] 2xl:text-[17px]'>
    Our vision is to shape spaces that foster success, well-being, and long-term value.
  </h6>

</div>


{/* Mission Column */}
<div data-aos="fade-right" className='flex-col items-center justify-center w-full py-16 mt-20 bg-gray-100 border-gray-200 md:border-r'>

  <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>
    <span className='text-[#4190ac]'>Mission</span>
  </h6>

  <div className='flex items-center justify-center w-full mt-1'>
    <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
    <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
  </div>

  <h6 className=' md:mt-5 text-center font_normal text-black w-[90%] md:w-[70%] mx-auto text-[14px] 2xl:text-[17px]'>
  To deliver reliable, high-quality facility management solutions that empower businesses to 
  operate efficiently.
  </h6>

</div>


{/* Core Values Column */}
<div data-aos="fade-left" className='flex-col items-center justify-center w-full py-16 bg-gray-100 border-t md:border-t-1 md:mt-20'>

  <h6 className='font_thicker text-center text-[21px] 2xl:text-[24px]'>
    <span className='text-[#4190ac]'>Core</span> <span className='text-[#4190ac]'>Values</span>
  </h6>

  <div className='flex items-center justify-center w-full mt-1'>
    <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
    <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
  </div>

  <h6 className=' mt-5 text-center text-black w-[90%] md:w-[70%] mx-auto text-[14px] 2xl:text-[17px]'>
    At Fidelitus Facility Management Services, we uphold a set of core values that guide us in every endeavor. These values define our culture and drive us to deliver excellence in all aspects of our work.
  </h6>

</div>

</div>


{/* Our Strengths Section */}
<div className="relative px-6 py-14 overflow-hidden bg-gradient-to-br from-[#f4fbfd] via-white to-[#eef8fb] md:px-[10%]">
  <div className="absolute top-[-70px] right-[-70px] w-[220px] h-[220px] rounded-full bg-[#4190ac]/10 blur-3xl animate-pulse"></div>
  <div className="absolute bottom-[-80px] left-[-70px] w-[240px] h-[240px] rounded-full bg-[#e58c3d]/10 blur-3xl animate-pulse"></div>

  <div className="relative max-w-6xl mx-auto text-center">
    <h6 data-aos="fade-up" className="font_thicker text-[24px] md:text-[34px] 2xl:text-[42px] text-slate-900">
      Our <span className="text-[#4190ac]">Strengths</span>
    </h6>

    <div data-aos="fade-up" data-aos-delay="100" className="flex items-center justify-center w-full mt-2">
      <span className="w-[80px] h-[3px] bg-[#e58c3d] block transition-all duration-500 hover:w-[120px]"></span>
      <span className="w-[30px] h-[6px] bg-[#e58c3d] block"></span>
    </div>

    <div className="grid gap-5 mt-10 md:grid-cols-4">
      {[
        "PAN India operational capability",
        "Highly trained and verified workforce",
        "Scalable solutions for diverse industries",
        "Strong focus on compliance and quality",
      ].map((item, i) => (
        <div
          key={i}
          data-aos="zoom-in"
          data-aos-delay={i * 120}
          className="group relative p-6 overflow-hidden transition-all duration-500 bg-white border border-[#4190ac]/10 rounded-2xl shadow-sm hover:-translate-y-2 hover:shadow-xl hover:border-[#4190ac]/30"
        >
          <div className="absolute inset-0 transition-all duration-500 opacity-0 bg-gradient-to-br from-[#4190ac]/10 to-[#e58c3d]/10 group-hover:opacity-100"></div>

          <div className="relative z-10 flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-[#4190ac]/10 text-[#4190ac] font_thicker transition-all duration-500 group-hover:bg-[#4190ac] group-hover:text-white group-hover:scale-110">
            {i + 1}
          </div>

          <h6 className="relative z-10 mt-5 text-[14px] 2xl:text-[17px] font_thicker text-slate-800 leading-relaxed transition-all duration-500 group-hover:text-[#4190ac]">
            {item}
          </h6>

          <div className="relative z-10 w-0 h-[3px] mx-auto mt-5 rounded-full bg-[#e58c3d] transition-all duration-500 group-hover:w-16"></div>
        </div>
      ))}
    </div>
  </div>
</div>





          <div className='px-[5%] md:px-[10%] pt-16'>
            <div className='md:w-[65%]'>
              <h6 className='font_thicker text-[17px] 2xl:text-[20px] border-l-4 border-[#e58c3d] pl-4'>Why we stand Out in Facility Management Service</h6>
              <div data-aos="fade-left" data-aos-delay="300" className='flex items-center justify-center w-full mt-1'>
              <span className='w-[80px] grid place-items-center justify-center group-hover:w-[120px] h-[3px] bg-[#e58c3d] block text-center'></span>
              <span className='w-[30px] grid place-items-center justify-center h-[6px] bg-[#e58c3d] block text-center'></span>
              </div>
            </div>

             <h6 className='text-[14px] 2xl:text-[17px] mt-4 font_normal'>We excel in facility management due to our dedicated team, comprehensive solutions, and client-centric approach. Our expertise ensures efficient operations, cost-effectiveness, and optimal tenant experiences, setting us apart as leaders in the industry.</h6>

             <div className='grid grid-cols-1 gap-2 my-10 md:grid-cols-5'>
                {stand_out?.map((s,i)=>(
                  <div key={i} data-aos="fade-up" data-aos-delay="300" className='flex flex-col items-center justify-center p-4 border cursor-pointer'>
                        <img alt={s?.img} src={s?.img} className='object-contain w-24 h-20 opacity-80' />
                        <h6 className='font_thicker font-[900] text-center  text-[13.5px] 2xl:text-[16.5px] mt-1.5'>{s?.name}</h6>
                        <h6 className='font_normal text-[12px] 2xl:text-[15px] text-center '>{s?.val}</h6>
                  </div> 
                ))}
             </div>
          </div>


          <div className='bg-[#f7f7f7] relative z-50 overflow-hidden px-[10%] w-full flex-col items-center justify-center mt-20 py-12 md:py-24 w-full flex-col items-center justify-center'>
            <div data-aos="fade-left" className='w-[75%] z-50 md:w-full'>
              <h6 className='font_thicker text-[19px] 2xl:text-[22px] z-50'>Grow Your Business with the best Facility Management Service Provider in india!.</h6>
              <h6 className='font_normal text-[14px] 2xl:text-[17px] z-50'>If you&apos;re Intrested in our Integrated facility management services contact us!.</h6>

              <a className='h-full' href={`tel:+${mobile}`} target='_blank'>

              <h6 className='w-[100px] uppercase p-1.5 text-center text-[11px] 2xl:text-[14px] mt-4 bg-black text-white'>Call Now</h6>
              </a>
            </div>
            <img alt={call} data-aos="fade-up" data-aos-delay="300"  src={call} className='absolute w-[60%] md:w-[30%] -right-[100px] md:right-0 -bottom-3 md:-bottom-8' />
          </div>   



        </div> 

    </div>
  )
}

export default About